/** 북마크(카드/임베드) 리사이즈 컨트롤러 — 좌/우 핸들 드래그로 previewWidth(px) 갱신.
 * 폭만 조절(카드=높이 자동, 임베드=비율 유지). 이미지/비디오 컨트롤러와 동일 패턴. */
import { startDragResize } from "../../shared/drag-resize.js";

const MIN_W = 260, MAX_W = 860;

export function attachBookmarkControls(editorEl, ctx) {
  const onChange = (ctx && ctx.onChange) || (() => {});
  const isEditable = () => !ctx || typeof ctx.isEditable !== "function" || ctx.isEditable();
  function onMousedown(e) {
    if (!isEditable()) return; // 읽기전용에선 리사이즈 비활성
    const h = e.target.closest && e.target.closest(".lumir-bookmark-handle");
    if (!h) return;
    e.preventDefault();
    const block = h.closest(".block");
    const inner = h.closest(".lumir-bookmark-inner");
    if (!block || !inner) return;
    if (!block.__props) block.__props = {};
    const measured = inner.getBoundingClientRect ? Math.round(inner.getBoundingClientRect().width) : 0;
    const startW = block.__props.previewWidth || measured || 480;
    // 임베드 iframe은 드래그 중 부모 document의 mousemove를 가로챈다 → 전체 화면 투명 오버레이로
    // 포인터 이벤트를 확실히 캡처(iframe 위에서도 드래그 유지). jsdom 등 body 없으면 생략.
    let shield = null;
    if (typeof document !== "undefined" && document.body) {
      shield = document.createElement("div");
      shield.style.cssText = "position:fixed;inset:0;z-index:99999;cursor:ew-resize;";
      document.body.appendChild(shield);
    }
    startDragResize(e, {
      axis: "x", startVal: startW, min: MIN_W, max: MAX_W, sign: h.classList.contains("left") ? -1 : 1,
      onMove: (w) => { block.__props.previewWidth = w; inner.style.width = w + "px"; },
      onEnd: () => { if (shield && shield.parentNode) shield.parentNode.removeChild(shield); onChange(); },
    });
  }
  editorEl.addEventListener("mousedown", onMousedown);
  return { destroy: () => editorEl.removeEventListener("mousedown", onMousedown) };
}
